import Store from '@/store'

export class CacheStoreUtils {

    static getAssetCacheInfo() {
        return Store.dispatch("cache-store/getAssetCacheInfo");
    }

    static cacheAssets() {
        return Store.dispatch("cache-store/cacheAssets");
    }
}